import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useB2cOperator = (b2c_daily_id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [dailyInfo, setDailyInfo] = useState<OperatorDailyItemDto>();
  const [operatorInfo, setOperatorInfo] = useState<OperatorItemDto[]>([]);
  const [scheculeInfo, setScheculeInfo] = useState<OperatorScheculeItemDto[]>([]);


  /* ======================================================
   * hooks
   * ====================================================== */
  const { refetch, isLoading } = useQuery(
    [endpoints.b2c.operator.info, b2c_daily_id],
    () =>
      fetcher.b2c.postProjectOperatorInfo({id: b2c_daily_id}),
    {
      enabled: (b2c_daily_id > 0),
      onSuccess: (res: ProjectOperatorInfoResDto) => {
        switch (res.code) {
          case 200:
            setDailyInfo(res.result?.info.daily);
            setOperatorInfo(res.result?.info.operator || []);
            setScheculeInfo(res.result?.info.schedule || []);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: operatorUpdate, isSuccess: isUpdated } = useMutation(
    [endpoints.b2c.operator.save],
    fetcher.b2c.postProjectOperatorSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  
  
  const { mutate: operatorDelete, isSuccess: isDeleted } = useMutation(
    [endpoints.b2c.operator.delete],
    fetcher.b2c.postProjectOperatorDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { refetch, isLoading, dailyInfo, operatorInfo, scheculeInfo, operatorUpdate, operatorDelete, isUpdated, isDeleted };
};

export default useB2cOperator;
